module.exports = __webpack_public_path__ + "static/media/egg-fried.2f9afb5f.svg";